import { Injectable } from '@angular/core';
import {Filter, SexFilter, StateFilter, StateLeagueFilter} from '@shared/components/filter/filter';
import {LeagueService} from '@core/services/league.service';
import {StateHttpService} from '@api/http/state/state-http.service';

type RemoveFirst<T extends unknown[]> = T extends [infer H, ...infer R] ? R : T;
type ExternalFilterParameters<T extends typeof Filter> = RemoveFirst<ConstructorParameters<T>>;


@Injectable({
  providedIn: 'root'
})
export class FilterService {

  constructor(private leagueService: LeagueService,
              private stateHttpService: StateHttpService) { }

  /**
   * Filter factory
   * creates an instance of a given filter class
   * there is no strict type check for Filter subclasses, it only ensures that an instance of the passed class is returned
   * @param filter class of filter to create instance of
   * @param constructorArguments arguments that are passed to the filter's ctr
   */
  create<T extends new (...args: any[]) => any>(filter: T, ...constructorArguments: ExternalFilterParameters<T>): InstanceType<T> {
    let instance;

    switch (filter) {
      case StateFilter:
        instance = new StateFilter(this.stateHttpService);
        break;
      case StateLeagueFilter:
        instance = new StateLeagueFilter(this.leagueService, constructorArguments[0], constructorArguments[1]);
        break;
      case SexFilter:
        instance = new SexFilter();
        break;
      default:
        instance = new Filter();
    }

    return instance;
  }
}
